import { defineMessages } from 'react-intl';

export default defineMessages({
    login: {
        defaultMessage: 'Log in',
        description: 'Text message for login header in Customer Portal',
        id: 'cv.login.title',
    },
});
